export const navList = [
  {
    text: "User Account Log In",
    href: "/users",
    title: "Search different types of number plates",
    icon: "account_circle",
  },
  {
    text: "Number Plates Search",
    href: "/number-plates-search",
    title: "Search different types of number plates",
    icon: "search",
  },
  {
    text: "Search Dateless Number Plates",
    href: "/dateless-number-plates",
    title: "Search dateless number plates",
    icon: "search",
  },
  {
    text: "Build A Number Plate",
    href: "/number-plate-builder",
    title: "Build a number plate for private registrations",
    icon: "build",
  },
  {
    text: "Cheap Registrations",
    href: "/search/search_results/navigation/contextual/listing/none/none/BARGAIN_PREFIX_PLATES/1/bargain_prefix",
    icon: "stars",
  },
  {
    text: "Purchase Physical Number Plates",
    href: "/buy/acrylic-number-plates/",
    icon: "build",
  },
  {
    text: "Number Plates Ideas",
    href: "/searchideas",
    icon: "lightbulb_outline",
  },
  {
    text: "Name Number Plates",
    href: "/whats_in_a_name",
    icon: "lightbulb_outline",
  },
  {
    text: "Future Releases",
    href: "/future-releases",
    icon: "lightbulb_outline",
  },
  {
    text: "Private Number Plates",
    href: "/private-number-plates",
    title: "Private Number Plates",
    icon: "stars",
  },
  {
    text: "Gift Ideas",
    href: "/personalised-registration-gift",
    title: "Private Number Plates",
    icon: "stars",
  },
  {
    text: "Plates For Businesses",
    href: "/fleet-brand-registrations",
    title: "Number Plates for Businesses",
    icon: "local_shipping",
  },
  {
    text: "Types of DVLA Registrations",
    href: "/services/registration_types",
    title: "Number Plates for Businesses",
    icon: "local_shipping",
  },
  {
    text: "History of the Motor Vehicle",
    href: "/number-plates-information/history-of-the-motor-vehicle/",
    title: "History of the Motor Vehicle",
    icon: "history",
  },
  {
    text: "History of UK Number Plates",
    href: "/number-plates-information/history-of-uk-number-plates/",
    title: "History of UK Number Plates",
    icon: "label",
  },
  {
    text: "About Number Plates",
    href: "/numberplates",
    icon: "info",
  },
  {
    text: "Selling a Number Plate",
    href: "/valuations/newreg_valuations_form",
    icon: "add_circle",
  },
  {
    text: "Valuation Terms & Conditions",
    href: "/valuations/commission_terms",
    icon: "add_circle",
  },
  {
    text: "Buyer’s Guide",
    href: "/help/buying-a-number-plate",
    icon: "info",
  },
  {
    text: "Number Plates on finance",
    href: "/number-plate-finance",
    icon: "info",
  },
  {
    text: "FAQs",
    href: "/help/faqs",
    icon: "info",
  },
  {
    text: "Downloads",
    href: "/downloads",
    icon: "file_download",
  },
  {
    text: "Physical Plate Information",
    href: "/services/dvla_number_plates",
    icon: "info",
  },
  {
    text: "Help",
    href: "/help",
    icon: "live_help",
  },
  {
    text: "Retention Scheme",
    href: "/services/retention_scheme",
    icon: "live_help",
  },
  {
    text: "List Of VROs",
    href: "/services/vehicle_registration_offices",
    icon: "live_help",
  },
  {
    text: "News and Information",
    href: "/blog",
    icon: "live_help",
  },
  {
    text: "Code of Practice",
    href: "/help/regulations/cnda-code-of-practice",
    icon: "live_help",
  },
  {
    text: "Shipping Policy",
    href: "/help/regulations/shipping-policy",
    icon: "live_help",
  },
  {
    text: "Returns Policy",
    href: "/help/regulations/returns-policy",
    icon: "live_help",
  },
  {
    text: "About New Reg",
    href: "/help/about-new-reg",
    icon: "info",
  },
  {
    text: "Contact Us",
    href: "/help/contact",
    icon: "mail",
  },
];
